<template>
  <div class="orderRenewal-enterpriseSub-add">
    <div class="steps-wrapper">
      <OrderRenewalStep :fixedStepIndex="originStep" :currentStepIndex="currentStep" :steps="stepList" />
    </div>

    <div>
      <keep-alive>
        <component
          :is="currentComponent"
          orderType="enterpriseSub"
          :orderDataList="orderDataList"
          @completeOrderSelect="handleCompleteOrderSelect"
        />
      </keep-alive>
    </div>
  </div>
</template>

<script>
import OrderRenewalStep from './components/orderRenewalStep/index.vue'
import OriginOrderInfo from './components/originOrderInfo/index.vue'
import RentInfo from './components/rentInfo/index.vue'
import { ENTERPRISE_SUB_ADD_STEPS } from './config'

export default {
  data() {
    return {
      originStep: 0,
      currentStep: 0,
      stepList: ENTERPRISE_SUB_ADD_STEPS,
      orderDataList: [],
    }
  },
  computed: {
    currentComponent() {
      if (this.currentStep === 0) {
        return 'OriginOrderInfo'
      }
      if (this.currentStep === 1) {
        return 'RentInfo'
      }
      return ''
    },
  },
  methods: {
    // 完成原订单选择的回调
    handleCompleteOrderSelect(data) {
      this.orderDataList = data
      this.originStep = 1
      this.currentStep = 1
    },
  },
  components: {
    OriginOrderInfo,
    OrderRenewalStep,
    RentInfo,
  },
}
</script>

<style lang="scss" scoped>
  .steps-wrapper {
    margin-top: 24px;
  }
</style>
